"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _reducers = require('shared/reducers'); var _reducers2 = _interopRequireDefault(_reducers);
var _reducers3 = require('web/reducers'); var _reducers4 = _interopRequireDefault(_reducers3);


const chatRootReducer = _reducers2.default(_reducers4.default)

exports. default = chatRootReducer
